var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLowPrice(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 41.5C32.3218 41.5 41.5 32.3218 41.5 21C41.5 9.67816 32.3218 0.5 21 0.5C9.67816 0.5 0.5 9.67816 0.5 21C0.5 32.3218 9.67816 41.5 21 41.5Z",
    fill: "white",
    stroke: "#378440"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8532 18.0357C23.7057 17.6174 23.4364 17.2527 23.08 16.9887C22.7236 16.7247 22.2963 16.5734 21.8532 16.5543H18.8902C18.3008 16.5543 17.7356 16.7884 17.3188 17.2051C16.9021 17.6219 16.668 18.1871 16.668 18.7765C16.668 19.3658 16.9021 19.9311 17.3188 20.3478C17.7356 20.7646 18.3008 20.9987 18.8902 20.9987H21.8532C22.4425 20.9987 23.0078 21.2328 23.4245 21.6496C23.8413 22.0663 24.0754 22.6316 24.0754 23.2209C24.0754 23.8103 23.8413 24.3755 23.4245 24.7923C23.0078 25.209 22.4425 25.4431 21.8532 25.4431H18.8902C18.447 25.424 18.0198 25.2727 17.6633 25.0087C17.3069 24.7446 17.0376 24.38 16.8902 23.9617M20.3717 14.332V16.5543M20.3717 25.4431V27.6654",
    stroke: "#378440",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowPrice);
export default __webpack_public_path__ + "static/media/low-price.11184eec61aa1795cdf3edef19bf87cb.svg";
export { ForwardRef as ReactComponent };